import { Banner } from '@customerio/pluma-components/react';

/**
 * Either read the page gates on can fail — the catalog entry or the saved record — and neither is
 * recoverable from here. They report identically so a failed load never reads as a different
 * outcome depending on which request lost.
 */
export function LoadErrorBanner() {
  return (
    <Banner
      variant="critical"
      title="We couldn't load this integration."
      description="Refresh the page to try again."
    />
  );
}
